import styled from "styled-components";

export const FormButtonBar = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
`;
